import React from 'react';
import Hero from '../components/Hero';
import './Home.css';

const services = [
  { icon: 'fas fa-tree', title: 'Farm Land', desc: 'Buy or sell premium agricultural land along ECR & OMR with full legal support.' },
  { icon: 'fas fa-map-marked-alt', title: 'Residential Plots', desc: 'DTCP-approved plots in prime coastal corridors, ready for construction.' },
  { icon: 'fas fa-file-contract', title: 'Legal Documentation', desc: 'End-to-end legal opinions, title verification, and document processing.' },
  { icon: 'fas fa-stamp', title: 'Registration', desc: 'Hassle-free property registration guided by our experts from start to finish.' },
  { icon: 'fas fa-road', title: 'ECR / OMR Specialist', desc: 'Exclusive listings and market intelligence along the fastest-growing corridors.' },
  { icon: 'fas fa-handshake', title: 'Investment Advisory', desc: 'Strategic real estate investment guidance tailored to your financial goals.' },
];

const Home = () => {
  return (
    <div className="home-page">
      <Hero />

      {/* ── Services section ── */}
      <section className="services-section">
        <div className="section-header">
          <span className="section-eyebrow">What We Do</span>
          <h2 className="section-title">Our Premium Services</h2>
          <p className="section-subtitle">
            Comprehensive real estate solutions trusted by hundreds of families along Chennai's prime coastal corridors.
          </p>
        </div>

        <div className="services-grid">
          {services.map(({ icon, title, desc }) => (
            <div key={title} className="service-card card-hover">
              <div className="service-icon-wrap">
                <i className={`${icon} service-icon`} />
              </div>
              <h3>{title}</h3>
              <p>{desc}</p>
              <span className="service-card-arrow">→</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── Why Vetri section ── */}
      <section className="why-section">
        <div className="why-inner glass-container">
          <div className="why-text">
            <span className="section-eyebrow">Why Choose Us</span>
            <h2 className="section-title" style={{ textAlign: 'left', maxWidth: '100%' }}>
              Trusted Real Estate Partners on ECR &amp; OMR
            </h2>
            <p className="section-subtitle" style={{ textAlign: 'left', margin: '1rem 0 2rem' }}>
              With deep local roots and unmatched market knowledge, Vetri Realtors delivers transparent, ethical, and personalized service at every step.
            </p>
            <ul className="why-list">
              {[
                'DTCP approved & legally verified properties',
                'Transparent pricing, no hidden charges',
                'End-to-end documentation assistance',
                'Dedicated post-sale support',
                'Trusted by 500+ satisfied clients',
              ].map(item => (
                <li key={item}>
                  <i className="fas fa-check-circle why-check" />
                  {item}
                </li>
              ))}
            </ul>
            <a href="/contact" className="cta-button cta-pulse" style={{ marginTop: '2rem' }}>
              <i className="fas fa-arrow-right" /> Get Free Consultation
            </a>
          </div>
          <div className="why-visual">
            <div className="why-badge">
              <span className="badge-number">2025</span>
              <span className="badge-text">Established</span>
            </div>
            <div className="why-badge why-badge--secondary">
              <span className="badge-number">ECR</span>
              <span className="badge-text">Specialists</span>
            </div>
            <div className="why-badge why-badge--tertiary">
              <span className="badge-number">OMR</span>
              <span className="badge-text">Corridor</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA Banner ── */}
      <section className="cta-banner">
        <div className="cta-banner-inner">
          <h2>Ready to Find Your Dream Property?</h2>
          <p>Connect with our experts today and let us guide you to the perfect investment.</p>
          <div className="cta-banner-buttons">
            <a href="/contact" className="cta-button">
              <i className="fas fa-envelope" /> Contact Us
            </a>
            <a href="tel:+918438623133" className="cta-button secondary">
              <i className="fas fa-phone-alt" /> +91 84386 23133
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;